import React, { useContext } from 'react';
import SectionTitle from '../../property-partners-portal/components/SectionTitle/SectionTitle';
import IconButton from '../../muiComponents/IconButton';
import { ContextContact } from '../../contexts/ContactContext';
import { getInstructionsData } from '../../utils/PublicSectionsUtils';
import Card from '../../muiComponents/Card';
import useTranslate from '../../customHooks/useTranslate';

const ContactInformation = () => {
    const translate = useTranslate();
    const { isInfoVisible, setIsInfoVisible } = useContext(ContextContact);

    const additionalInfoData = getInstructionsData('contact');

    return (
        <>
            <div className='title__container'>
                <SectionTitle title={additionalInfoData.title} />
                <IconButton
                    iconName='InfoOutlinedIcon'
                    onClick={() => setIsInfoVisible(prevState => !prevState)}
                />
            </div>
            {isInfoVisible && (
                <Card className='additional-info__container'>
                    <div>
                        {additionalInfoData.paragraphs.map(para => (
                            <p className='additional_info' key={para.id}>
                                {translate(para.text)}
                            </p>
                        ))}
                    </div>
                </Card>
            )}
        </>
    );
};

export default ContactInformation;
